/**
 * Leaded Order Detection Utility
 * 
 * Detects single glazed leaded orders that require temporary rack instead of regular rack
 */

/**
 * Check if an order is a single glazed leaded order
 * 
 * Single glazed leaded orders require temporary rack instead of regular rack.
 * An order is considered "leaded" when:
 * - product_type is 'single'
 * - decorative_leaded_pattern has a value (not null, not blank, not dash)
 * 
 * @param order - The order to check
 * @returns true if order is single glazed AND has decorative leaded pattern
 * 
 * @example
 * const order = { product_type: 'single', decorative_leaded_pattern: 'square' };
 * isOrderLeaded(order); // Returns: true
 * 
 * @example
 * const order = { product_type: 'double', decorative_leaded_pattern: 'square' };
 * isOrderLeaded(order); // Returns: false (not single)
 * 
 * @example
 * const order = { product_type: 'single', decorative_leaded_pattern: null };
 * isOrderLeaded(order); // Returns: false (no leaded pattern)
 */
export function isOrderLeaded(order: any): boolean {
  // Must be single glazed
  if (order.product_type !== 'single') {
    return false;
  }
  
  // Must have decorative leaded pattern (not null, not blank, not dash)
  const pattern = order.decorative_leaded_pattern;
  
  if (!pattern) {
    return false;
  }
  
  const trimmedPattern = pattern.trim();
  
  // Pattern must not be empty or just a dash
  return trimmedPattern !== '' && trimmedPattern !== '-';
}
